import { render, staticRenderFns } from "./question-group-edit.vue?vue&type=template&id=84aa3fe8"
import script from "./question-group-edit.vue?vue&type=script&lang=ts"
export * from "./question-group-edit.vue?vue&type=script&lang=ts"
import style0 from "./question-group-edit.vue?vue&type=style&index=0&id=84aa3fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports